import { Container, Grid } from "@mui/material";
import LogsTable from "./logsTable.tsx";
import React, { useState } from "react";

export default function Logs(){
    const [field, setField] = useState('');
    const [loadingData, setLoadingData] = useState(true);
    const [priority, setPriority] = useState("open");
    const [searchContent, setSearchContent] = useState('');
    const [searchTags, setSearchTags] = useState([]);
    const [valuesList, setValuesList] = useState([]);

    return (<Container maxWidth="xg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={1}>
        <Grid item xs={12} sm={12}>
            <Grid item xs={12}>
                <LogsTable
                    setLoadingData={setLoadingData}
                    setValuesList={setValuesList}
                    setField={setField}
                    priority={priority}
                    searchContent={searchContent}
                />
            </Grid>
        </Grid>
        </Grid>
    </Container>)
}